/** Shared default column widths for resizable catalog maintenance tables. */

export const VENDOR_LIST_COLUMN_WIDTHS = {
  check: 48,
  id: 72,
  vendor: 220,
  stato: 120,
  feed: 300,
  mapping: 110,
  import: 150,
  products: 88,
  actions: 110,
};

export const MAPPING_COLUMN_WIDTHS = {
  __index__: 56,
  __error__: 220,
  __actions__: 72,
};

export const CATALOG_OUTPUT_COLUMN_WIDTHS = {
  __row__: 56,
  errors: 220,
};
